import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Coverage, PatientResponsibility } from "risa-data-model";

import { FirestoreService } from "../../../../shared/api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../../shared/api/firebase/references";
import { DataState } from "../../store/store";

const initialPatientResponsibilityState: DataState<
  Map<string, PatientResponsibility>[]
> = {
  loading: false,
  error: null,
  data: null,
};

const patientResponsibilitySlice = createSlice({
  name: "PatientResponsibilitySlice",
  initialState: initialPatientResponsibilityState,
  reducers: {
    setPatientResponsibilityData(
      state: DataState<Map<string, PatientResponsibility>[]>,
      action: PayloadAction<Map<string, PatientResponsibility>[]>,
    ) {
      state.data = action.payload;
      state.error = null;
      state.loading = false;
    },
    setError(
      state: DataState<Map<string, PatientResponsibility>[]>,
      action: PayloadAction<string>,
    ) {
      state.error = action.payload;
    },
    setLoading(
      state: DataState<Map<string, PatientResponsibility>[]>,
      action: PayloadAction<boolean>,
    ) {
      state.loading = action.payload;
    },
    resetPatientResponsibilityData(
      state: DataState<Map<string, PatientResponsibility>[]>,
    ) {
      state.data = null;
      state.error = null;
      state.loading = false;
    },
  },
});

export const {
  setPatientResponsibilityData,
  setError,
  setLoading,
  resetPatientResponsibilityData,
} = patientResponsibilitySlice.actions;

export const getPatientResponsibilityData =
  (orderId: string, insuranceType: string) => async (dispatch: any) => {
    dispatch(setLoading(true));
    const data = FirestoreService.listenToQueryCollection<Coverage>(
      FirestoreCollectionReference.coverage(orderId),
      (documents) => {
        const validDocument = documents.filter(
          (doc) => doc["id"] === insuranceType,
        );
        const patientResponsibility = validDocument.map(
          (doc) => doc.PatientResponsibilities,
        );
        const patientResponsibilityData = patientResponsibility.filter(
          (
            patientResponsibility,
          ): patientResponsibility is Map<string, PatientResponsibility> =>
            patientResponsibility !== undefined &&
            patientResponsibility !== null,
        );
        if (patientResponsibilityData && patientResponsibilityData.length > 0) {
          dispatch(setPatientResponsibilityData(patientResponsibilityData));
        } else {
          dispatch(setPatientResponsibilityData([]));
        }
      },
      (error: any) => {
        dispatch(setError(error.message));
      },
    );
    return data;
  };

export default patientResponsibilitySlice.reducer;
